module.exports = __webpack_public_path__ + "static/media/A0.6803eaa8.svg";